'use strict';

exports.__esModule = true;
exports.default = {
  BLUE: 'blue',
  WHITE: 'white'
};
//# sourceMappingURL=MessengerColor.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-facebook/lib/constants/MessengerColor.js
// module id = 341
// module chunks = 0